import type { UserPresence } from "@bezoned/shared/types/api/user/user-presence-get.types.js";
import type { UserAvailability } from "@bezoned/shared/types/user-presence.js";
import { createContext } from "react";

interface PresenceContextType {
  __ctx_init: boolean;
  presence: UserPresence | null;
  availability: UserAvailability | null;
  presenceStatus: "loading" | "ready" | "error";
  presenceError: unknown;
  updateAvailability: (availability: UserAvailability) => Promise<void>;
  updateStatusMessage: (statusMessage: string | null) => Promise<void>;
}

export const PresenceContext = createContext<PresenceContextType>({
  __ctx_init: false,
  availability: null,
  presence: null,
  presenceError: null,
  presenceStatus: "loading",
  updateAvailability: () => {
    throw new Error("updateAvailability not implemented");
  },
  updateStatusMessage: () => {
    throw new Error("updateStatusMessage not implemented");
  },
});
